module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-7-01ee6eeb8fb73dda144ea79c811e48ac.jpg";